// ─────────────────────────────────────────────────────────────────────────────
// OAUTH1 — hyrja me Google/Apple BRENDA aplikacionit (8 shtator 2026)
//
// Apple, Guideline 4 (build 202609042047): «the user is taken to the default
// web browser to register for an account». Shkaku: në native, `signInWithOAuth`
// e çonte WebView-in te accounts.google.com / appleid.apple.com — një adresë e
// huaj për Capacitor-in, që e hap në Safari-n e sistemit. Personi dilte nga
// app-i, dhe kthehej vetëm nëpërmjet skemës `com.pemaefamiljes.app://`.
//
// TANI. Supabase vetëm e ndërton adresën (`skipBrowserRedirect`), dhe atë e hap
// `@capacitor/browser`: SFSafariViewController në iOS, Custom Tabs në Android —
// një fletë BRENDA app-it, me adresën dhe certifikatën të dukshme, pikërisht
// ajo që kërkon Apple. Google e lejon (nuk është WebView i fshehur). Kthimi
// mbetet i njëjti: skema e app-it → `appUrlOpen` → sesioni; pastaj fleta mbyllet.
//
// Në web s'ndryshon asgjë: ridrejtimi i zakonshëm, si më parë.
// ─────────────────────────────────────────────────────────────────────────────
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { App as CapacitorApp } from "@capacitor/app";
import { supabase } from "./supabaseClient";
import { shenoHyrjen } from "./gjurma.js"; // HYRJET1 — gjurma e derës

// appId-ja e capacitor.config.json — Capacitor e regjistron vetë si skemë URL-je.
// Duhet të jetë EDHE te Supabase → Authentication → URL Configuration → Redirect URLs.
export const SKEMA_E_KTHIMIT = "com.pemaefamiljes.app://auth-callback";

export const eshteNative = () => Capacitor.isNativePlatform();

/** Hyrja me Google/Apple. Kthen `null` ose gabimin (objekt me `message`). */
export async function hyrMeOAuth(provider, kthimiNeWeb) {
  const native = eshteNative();
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: native ? SKEMA_E_KTHIMIT : kthimiNeWeb,
      skipBrowserRedirect: native,
      // Apple: kërkohen shprehimisht emri dhe email-i — pyetja «Share / Hide My
      // Email» del vetëm herën e parë dhe vetëm kur kërkohet email-i (12 shtator 2026).
      ...(provider === "apple" ? { scopes: "name email" } : {}),
    },
  });
  if (error) return error;
  if (native && data && data.url) {
    try {
      await Browser.open({ url: data.url, presentationStyle: "popover" });
    } catch (_e) {
      // Pa plugin (pako e painstaluar) — rruga e vjetër, që të mos mbetet pa hyrje.
      window.location.assign(data.url);
    }
  }
  return null;
}

/** Mbyll fletën e shfletuesit brenda app-it (pas kthimit). E padëmshme në web. */
export async function mbyllShfletuesin() {
  if (!eshteNative()) return;
  try { await Browser.close(); } catch (_e) { /* s'ishte e hapur */ }
}

/**
 * Përpunon adresën e kthimit `com.pemaefamiljes.app://auth-callback?…` dhe e
 * mbyll sesionin te Supabase. Kthen `null` në sukses, ose tekstin e gabimit.
 *
 * Parametrat lexohen me emër, jo me kërkim tekstual: një dështim vjen si
 * `?error=…&error_code=…` dhe përmban vargun «code=» brenda `error_code` —
 * leximi tekstual e merrte dështimin për sukses (28 gusht 2026).
 * Mbulohen të dyja rrjedhat: implicit (`#access_token=`) dhe PKCE (`?code=`).
 */
export async function perpunoKthiminEOAuth(url) {
  const pyetja = url.includes("?") ? url.slice(url.indexOf("?") + 1).split("#")[0] : "";
  const thyerja = url.includes("#") ? url.slice(url.indexOf("#") + 1) : "";
  const nga = new URLSearchParams(pyetja), ngaThyerja = new URLSearchParams(thyerja);
  const merr = (emri) => nga.get(emri) || ngaThyerja.get(emri);
  const arsyeja = merr("error_description") || merr("error");
  if (arsyeja) return String(arsyeja);
  const access_token = merr("access_token"), refresh_token = merr("refresh_token");
  if (access_token && refresh_token) {
    const { error } = await supabase.auth.setSession({ access_token, refresh_token });
    return error ? error.message : null;
  }
  const kodi = merr("code");
  if (kodi) {
    const { error } = await supabase.auth.exchangeCodeForSession(kodi);
    return error ? error.message : null;
  }
  return "no_data";
}

/**
 * Dëgjuesi i kthimit në native: `appUrlOpen` me skemën tonë → mbyll fletën →
 * përpuno → `onGabim(tekst)` nëse dështoi. Kthen funksionin e çregjistrimit.
 * Faqet jashtë App.jsx (/start, /join, /invite) e përdorin njësoj.
 */
export function degjoKthiminEOAuth(onGabim) {
  if (!eshteNative()) return () => {};
  let handle = null;
  CapacitorApp.addListener("appUrlOpen", async (data) => {
    const url = (data && data.url) || "";
    if (!url.startsWith("com.pemaefamiljes.app://")) return;
    await mbyllShfletuesin();
    try {
      const gabimi = await perpunoKthiminEOAuth(url);
      if (gabimi) shenoHyrjen("oauth_fail", { ok: false, reason: gabimi }); // HYRJET1 (suksesi shkon te login_history)
      if (gabimi && onGabim) onGabim(gabimi);
    } catch (e) {
      shenoHyrjen("oauth_fail", { ok: false, reason: (e && e.message) || String(e) }); // HYRJET1
      if (onGabim) onGabim((e && e.message) || String(e));
    }
  }).then((h) => { handle = h; }).catch(() => {});
  return () => { if (handle && handle.remove) handle.remove(); };
}
